module.exports = __webpack_public_path__ + "img/ghbourges.a9e2768c.jpg";